module.exports = __webpack_public_path__ + "static/media/wild_swarm.push.76052253.jpeg";